import React , {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table } from 'react-bootstrap'

import Meta from '../components/Meta'

export const TermsandConditionsScreen = ({match, history}) => {

    
    const dispatch = useDispatch()

   
    useEffect(() => {
       

    }, [])





    return(



        <div style={{padding:'20px'}}>

<h1>TERMS AND CONDITIONS</h1>

<h5>Effective date: May 01,2025</h5>


<ListGroup style={{border:'None'}}>

    <ListGroup.Item style={{border:'None'}}>

<p>
PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY. BY ACCESSING OR USING THIS WEBSITE YOU AGREE TO BE BOUND BY THESE TERMS AND OUR <Link to='/privacy-policy'>PRIVACY POLICY</Link>.
Pixagan Technologies Private Limited ("Company", “We”, “Our” or “Us”) operates the website laeyerz.com (the “Site”). The Site serves as the landing page and documentation portal for Laeyerz, an open‑source Python library for building AI workflows and agents. These terms and conditions (“Terms”) describe the terms on which We grant You access to the Site and related resources (collectively, the “Services”). By using the Services, You confirm that You are at least 18 years old, or that You are using the Services under the consent and supervision of a parent or legal guardian. If We have previously prohibited You from accessing the Services, You are not permitted to access or use them.
</p>
</ListGroup.Item>




<ListGroup.Item style={{border:'None'}}>
<h5>1. TERMS OF SERVICE</h5>
By choosing to access or use the Services (including without limitation browsing the Site, reading documentation, and viewing examples), You agree to these Terms and the Privacy Policy, as each may be updated from time to time. If You do not agree to these Terms, please discontinue use of the Services.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>2. SYSTEM REQUIREMENTS</h5>
Use of the Services requires one or more compatible devices, internet access (fees may apply), and certain software (fees may apply), and may require obtaining updates or upgrades from time to time. Due to the fact that use of the Services involves hardware, software, and internet access, your ability to access and use the Services may be affected by the performance of these factors. High speed internet access is recommended. You acknowledge and agree that such system requirements, which may be changed from time to time, are your responsibility.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>3. DESCRIPTION OF SERVICES</h5>
The Site provides documentation, examples, code snippets, tutorials, and other resources related to the open‑source Laeyerz Python library. The Site may also link to community resources, third‑party services, and the public source code repository. Content on the Site is provided for informational purposes on an “as‑is” basis and may change without notice.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>4. LICENSE TO USE</h5>
We grant You a limited, revocable, non‑exclusive, non‑transferable license to access and use the Site for personal or organizational informational purposes. This license does not include any right to copy, modify, host, sell, resell, or commercially exploit the Site or its non‑code content.
The Laeyerz library source code is provided under its open‑source license as specified in the project repository. Your rights to use the Laeyerz codebase are governed exclusively by that open‑source license, not by these Terms. Code samples or snippets on the Site are licensed under the same license that applies to the referenced repository or as otherwise noted.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>5. INTELLECTUAL PROPERTY; TRADEMARKS</h5>
Except for content covered by open‑source licenses as noted above, We and our licensors retain all rights, title, and interest in and to the Site and its content, including all copyrights, trademarks, logos, and trade dress. “Laeyerz” and related marks are trademarks or service marks of their respective owners. Third‑party names and logos are the property of their respective owners and are used for identification purposes only.
</ListGroup.Item>


<ListGroup.Item style={{border:'None'}}>
<h5>6. ACCEPTABLE USE</h5>
Users must comply with the laws that apply to You in the location where You access the Services. Notwithstanding any other provision of these Terms, You agree not to:
<ul>
<li>
Access, interfere with, or disrupt the Site or its servers using automated means (including bots, scrapers, or crawlers) except for standard search engine indexing or as permitted by a publicly documented API;
</li>
<li>
Reverse engineer or attempt to derive the Site’s non‑open source software or underlying components, except to the extent such restriction is prohibited by applicable law;
</li>
<li>
Upload, transmit, or distribute any malware, spyware, or other malicious code;
</li>
<li>
Use the Services in any manner that infringes or violates the rights of others, or that is unlawful, misleading, or fraudulent;
</li>
<li>
Remove or obscure any proprietary notices on the Site; or
</li>
<li>
Misrepresent or imply that Your use of the Laeyerz library or any output generated thereby is endorsed by or created by Us when it is not.
</li>
</ul>
</ListGroup.Item>


<ListGroup.Item style={{border:'None'}}>
<h5>7. DISCLAIMER; THIRD‑PARTY SERVICES; LIMITATION OF LIABILITY</h5>
The Services and all content on the Site are provided “as is” and “as available” without warranties of any kind, whether express or implied, including but not limited to warranties of accuracy, non‑infringement, merchantability, and fitness for a particular purpose. Content may contain errors or be incomplete or out of date.
Documentation and examples may reference or integrate third‑party services (for example, AI model providers or databases). You are solely responsible for Your accounts, credentials, API keys, usage, and charges with any third‑party services, and for complying with those third parties’ terms and policies. Links to third‑party websites are provided for convenience only and do not constitute endorsement.
To the maximum extent permitted by law, in no event shall We be liable for any indirect, incidental, special, consequential, exemplary, or punitive damages, or any loss of profits, revenue, data, or goodwill, arising out of or related to Your use of or inability to use the Services, even if advised of the possibility of such damages. We do not warrant that the Services will be uninterrupted, secure, or error‑free. We will not be liable for any failure to perform due to causes beyond our reasonable control.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>8. AMENDMENTS TO TERMS</h5>
We may modify these Terms to, for example, reflect changes to the law, our Services, or our practices. Updates will be posted on this page with an updated effective date. Please check this page periodically for changes.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>9. TERMINATION</h5>
We may remove, restrict, cancel, or suspend Your access to the Services if We reasonably believe that You have breached these Terms or applicable law. You may cease using the Services at any time. Termination does not affect rights or obligations that have already accrued.
</ListGroup.Item>


<ListGroup.Item style={{border:'None'}}>
<h5>10. INDEMNITY</h5>
You agree to indemnify and hold harmless Us, Our contributors, maintainers, contractors, and licensors, and our respective directors, officers, employees, and agents from and against any and all claims and expenses, including reasonable attorneys’ fees, arising out of Your use of the Services or violation of these Terms.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>11. SEVERABILITY</h5>
If any court or competent authority finds that any provision of these Terms (or part of any provision) is invalid, illegal or unenforceable, that provision or part-provision shall, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of these Terms shall not be affected.
</ListGroup.Item>


<ListGroup.Item style={{border:'None'}}>
<h5>12. ASSIGNMENT</h5>
Any rights and licenses granted hereunder shall not be transferred or assigned by You but, shall be assigned by the Company. Any attempted transfer or assignment in violation hereof shall be considered as null and void.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>13. WAIVER</h5>
No waiver of any terms of these Terms shall be treated as a further or continuing waiver of such term or any other term and the Company’s failure to assert any right or provision under these Terms shall not constitute a waiver of such right or provision.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>14. GOVERNING LAW AND JURISDICTION</h5>
These Terms shall be governed by and construed in accordance with the laws of India, which are not in conflict with each other. Any and all such disputes arising out of or in relation to these Terms shall be subjected to the exclusive jurisdiction of the competent courts of Kochi, Kerala, India.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>15. FEEDBACK AND CONTRIBUTIONS</h5>
We welcome feedback and contributions. If You submit suggestions or feedback, You grant Us a non‑exclusive, worldwide, perpetual, irrevocable, royalty‑free license to use and incorporate them without restriction or compensation. Contributions to the Laeyerz code or documentation via the public repository are subject to the repository’s open‑source license and any applicable contributor guidelines. By submitting feedback, You represent and warrant that:
<ul>
<li>
(i) Your feedback does not contain confidential or proprietary information of You or third parties;
</li>
<li>
(ii) We are not under any obligation of confidentiality with respect to the feedback; 
</li>
<li>
(iii) We may have something similar to the feedback already under consideration or in development.
</li>
</ul>
</ListGroup.Item>


<ListGroup.Item style={{border:'None'}}>
<h5>16. CONTACT</h5>
<p>
If You have any questions about these Terms, please contact Us by email or postal mail at the following address:</p>

<p>Project: Laeyerz (maintained by Pixagan Technologies Private Limited)</p>
<p>Name: Anil Variyar</p>
<p>E‑mail: pixagan@gmail.com</p>
<p>Address: 39/2475-B1, Suite#244</p>
<p>LR Towers, SJRRA 104,</p>
<p>S Janatha Road, Palarivattom,</p>
<p>Kochi, Kerala, 682025</p>

</ListGroup.Item>
</ListGroup>


        </div>



    )


}

export default TermsandConditionsScreen




